import { postPresentCancel } from '../api/postPresentCancel';
import { setGetPresentList } from './setGetPresentList';

const setPostPresentCancel = (params) => {
    return async (dispatch, getState) => {
        try {
            await postPresentCancel(params);
            dispatch(setGetPresentList({
                page: 1,
                rowsPerPage: 10,
                search: ''
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostPresentCancel
}